import { render, staticRenderFns } from "./EquipmentCategoriesView.vue?vue&type=template&id=50dfceff"
import script from "./EquipmentCategoriesView.vue?vue&type=script&lang=js"
export * from "./EquipmentCategoriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports